










import { Component, Vue } from "vue-property-decorator";
import firebaseConfig from "./config/firebase";
import firebase from "firebase";
import Navbar from "./components/Navbar.vue";
import Hero from "./components/Hero.vue";
import Projects from "./components/Projects.vue";
import Panels from "./components/Panels.vue";
import { project } from "../types";
import "gsap/TweenMax";
//import projectsContent from './assets/feeds/projects'

@Component({
	components: {
		Navbar,
		Hero,
		Projects,
		Panels
	}
})
export default class App extends Vue {
	$refs!: {
		panels: Panels;
		navbar: Navbar;
	};
	projects: project[] = [];
	ready: boolean = false;
	fbRef: any = null;

	created() {
		// Initialize Firebase
		firebase.initializeApp(firebaseConfig);
		// firebase.analytics();

		var ref = firebase.firestore();
		var projectsCollection = ref.collection("projects");
		var _projects: project[] = [];
		this.fbRef = ref;
		// todo!
		//updateProjects(projectsCollection);
		//newProject(projectsCollection);

		projectsCollection.get().then(querySnapshot => {
			querySnapshot.forEach(doc => {
				_projects.push(doc.data() as project);
			});
			this.projects = _projects.sort((a, b) => (a.index > b.index ? 1 : -1));
			this.ready = true;
		});
	}

	public toggle(target: string) {
		this.$refs.panels.togglePanel(target);
	}

	public contactSubmit() {}

	public close() {
		this.$refs.navbar.close();
	}

	public sendMessage(msg: any) {
		var msgCollection = this.fbRef.collection("messages");
		msgCollection
			.add(msg)
			.then(function(docRef: any) {
				console.log("Document written with ID: ", docRef.id);
				alert("Thanks! I will get back to you as soon as possible.");
			})
			.catch(function(error: any) {
				alert("Error - sending message - shoot me an email instead. sorry...");
				console.error("Error adding document: ", error);
			});
	}
}

// function updateProjects(collection:any){

//     for(var proj of Object.entries(projectsContent)){
//         collection
//         	.doc(proj[0])
//         	.set(proj[1], { merge: true });
//     }

// }

// function newProject(collection:any){
//     var project: project = {
//         title: "Website",
//         subtitle: "Metroservice",
//         text: "new text",
//         image: "new image",
//         link: "new link",
//         index: 99,
// 		imageCaption: "new imageCaption",
// 		linkText: 'Visit'
//     }
//     collection.add(project).then(function (docRef:any) {
//         console.log("Document written with ID: ", docRef.id);
//         alert("Document written with ID:  " + docRef.id)
//     })
//         .catch(function (error:any) {
//             console.error("Error adding document: ", error);
//         });
// }
